import * as THREE from 'three';
import { generateUniqueId } from '../utils/generateUniqueId';
export function drawLineFromCode(target, start, end, color = 0xffffff, options = {}) {
  const { layerName = '0', opacity = 1.0 } = options;
  if (!start || !end) return;

  const geometry = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(start.x, start.y, 0),
    new THREE.Vector3(end.x, end.y, 0),
  ]);

  // ✅ Transparency desteği: opacity < 1 ise transparent aktif
  const materialOptions = { color };
  if (opacity < 1) {
    materialOptions.transparent = true;
    materialOptions.opacity = 1 - opacity;
  }
  const material = new THREE.LineBasicMaterial(materialOptions);
  const line = new THREE.Line(geometry, material);

  line.userData = {
    id: generateUniqueId('line'),
    type: 'line',
    start: start,
    end: end,
    isSelectable: true,
    originalColor: color,
    layerName,
  };

  //scene.add(line);
  if (target) target.add(line);
  return line;
}
/*    KULLANIM
      drawLineFromCode(scene, {
        start: { x: 0, y: 0 },
        end: { x: 200, y: 200 },
        color: 0x00ff00,
      });
    
 */